import { DeviceLimit, SUBSCRIPTION_TYPE } from "../context/types";

// Цены черновые (временные) — синхронизированы с open-way-back/src/common/tarrifes.ts.
export const TARIFFS: Record<SUBSCRIPTION_TYPE, Record<DeviceLimit, number>> = {
  [SUBSCRIPTION_TYPE.TEST]: { 3: 0, 5: 0, 10: 0 },
  [SUBSCRIPTION_TYPE.M1]: { 3: 249, 5: 349, 10: 549 },
  [SUBSCRIPTION_TYPE.M3]: { 3: 699, 5: 999, 10: 1599 },
  [SUBSCRIPTION_TYPE.M6]: { 3: 1299, 5: 1799, 10: 2899 },
  [SUBSCRIPTION_TYPE.M12]: { 3: 2399, 5: 3399, 10: 5499 }
};

export function getTariffPrice(subscriptionType: SUBSCRIPTION_TYPE, deviceLimit: DeviceLimit): number {
  return TARIFFS[subscriptionType][deviceLimit];
}
